<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>
<script>
import MqttService from '@/utils/mqttService.js';
import { getUnreadCount } from '@/utils/api/studentAppoint.js'
import { setOemConfig, applyFaviconFromConfig } from '@/utils/oemConfig.js'
import { getOemConfig } from '@/utils/api/public.js'

export default {
  name: "App",
  data() {
    return {
      userInfo: null,
      token: null,
    };
  },
  created() {
    document.title = process.env.VUE_APP_TITLE;
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
    this.token = localStorage.getItem('token');

    this.checkAndInitMqtt();
    
    // 监听 localStorage 变化（跨标签页登录）
    window.addEventListener('storage', this.handleStorageChange);
    
    // 请求租户列表接口
    this.getTenantList();
  },

  watch: {
    // 监听路由变化，确保在登录后初始化 MQTT
    '$route'(to, from) {
      this.checkAndInitMqtt();
    }
  },

  methods: {
    // 获取租户列表
    async getTenantList() {
        const domainInfo = this.getCurrentDomainInfo();
        const localDomain = domainInfo.hostname;
        console.log('请求参数 - 本地域名:', domainInfo);
        
        const res = await getOemConfig({
          domain: localDomain
        });
        if(res.data.data.voList.length > 0){
           res.data.data.voList.forEach(item => {
             if(item.domain.includes(localDomain)){
               setOemConfig(item);
               document.title = item.companyName + process.env.VUE_APP_TITLE;
              
              // 动态更换浏览器图标
              this.changeFaviconFromTenant(item);

             }
           });
        }
    },
    getCurrentDomainInfo() {
      const location = window.location;
      const protocol = location.protocol;
      const hostname = location.hostname;
      const port = location.port;
      
      return {
        protocol,
        hostname,
        port,
        fullUrl: `${protocol}//${hostname}${port ? ':' + port : ''}`,
        isLocalhost: hostname === 'localhost' || hostname === '127.0.0.1',
        isLocalNetwork: hostname.match(/^192\.168\.|^10\.|^172\.(1[6-9]|2[0-9]|3[0-1])\./)
      };
    },
    // 检查并初始化 MQTT 连接
    checkAndInitMqtt() {
      // 判断当前页面是否是登录页
      const isLoginPage = this.$route.path === '/' || this.$route.path === '/stuLogin';
      if(isLoginPage){
        return;
      }
      const userInfo = JSON.parse(localStorage.getItem('userInfo')); // 从 localStorage 获取用户信息
      const token = localStorage.getItem('token'); // 获取 token
      
      if (userInfo && token && !MqttService.mqttClient) {
        this.initMqttConnection(userInfo);
      } else if ((!userInfo || !token) && MqttService.mqttClient) {
        MqttService.disconnectMqtt();
      }
    },
    
    // 初始化 MQTT 连接
    initMqttConnection(userInfo) {
      const mqttUrl = process.env.VUE_APP_MQTT_URL; // 从环境变量获取 MQTT 地址
      const options = {
        username: process.env.VUE_APP_MQTT_ACC,
        password: process.env.VUE_APP_MQTT_PWD // 使用 token 作为密码
      };
      
      MqttService.initMqtt(mqttUrl, options)
        .then(() => {
          MqttService.subscribeToUserTopic(userInfo);
          MqttService.onMessage(this.getNotificaNum);
          this.getNotificaNum();
        })
        .catch(error => {
          console.error('MQTT connection failed:', error);
          this.$notify.error({
            title: 'MQTT 连接失败',
            message: '实时消息服务不可用'
          });
        });
    },
    
    // 处理 localStorage 变化
    handleStorageChange(event) {
      if (event.key === 'userInfo' || event.key === 'token') {
        this.checkAndInitMqtt();
      }
    },

    // 获取未读消息数量
    getNotificaNum() {
      return getUnreadCount().then(res => {
        if (res.data.code == 200) {
          this.$store.commit('changeCountMessage', res.data.data)
        }
      })
    },

    // 从租户信息中更换图标
    changeFaviconFromTenant(tenantInfo) {
      try {
        // 检查租户信息中是否包含图标配置
        if (tenantInfo.ossPath) {
          
          // 应用图标配置
          const success = applyFaviconFromConfig(tenantInfo);
          if (success) {
            console.log('浏览器图标更换成功');
          } else {
            console.warn('浏览器图标更换失败，使用默认图标');
          }
        } else {
          console.log('租户信息中未包含图标配置，使用默认图标');
        }
      } catch (error) {
        console.error('更换图标时发生错误:', error);
      }
    },
  },

  beforeDestroy() {
    // 组件销毁时断开 MQTT 连接
    MqttService.disconnectMqtt();
    window.removeEventListener('storage', this.handleStorageChange);
  },
};
</script>
<style lang="scss">

#app {
  
  box-sizing: border-box;
  *,
  *:before,
  *:after {
    box-sizing: inherit;
  }
  /* end */
}
* {
  margin: 0;
  padding: 0;
}
</style>
